const submenuItems = [
  {
    header: 'Health',
    items: [
      { title: 'Vision Insurance', url: '/vision-insurance/', },
      { title: 'Long-term Care Insurance', url: '/long-term-care-insurance/', },
      { title: 'Prescription Discount Cards', url: '/prescription-discount-cards/', },
    ],
  },
  {
    header: 'Other',
    items: [
      { title: 'Pet Insurance', url: '/pet-insurance/' },
      { title: 'Jewelry Insurance', url: '/jewelry-insurance/', },
      { title: 'Identity Theft Insurance', url: '/identity-theft-insurance/', },
      { title: 'Travel Insurance', url: '/travel-insurance/', },
    ],
  },
];

export default {
  menu: {
    header: 'More Products',
    shortHeader: 'More',
    activeName: 'more',
    columns: 2,
  },
  intro: {
    icon: 'policygeniusSymbolCenter',
  },
  list: {
    key: 'more-submenu-list-',
    items: submenuItems,
    type: 'links',
  }
};



// WEBPACK FOOTER //
// ../src/templates/MainNav/data/products/moreData.js